export default {"src":"/_next/static/media/dth.e8ba8d0a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};